module.exports = __webpack_public_path__ + "static/img/Darts-Off.09e89115.svg";